import React from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import KpiForecastsQV from './KpiForecastsQV';
import FinanceInsightsWidgets from './FinanceInsightsWidgets';
import AdvancedDataPerformance from './AdvancedDataPerformance';
import FinanceGranularityChartWidgets from './FinanceGranularityChartWidgets';
import PreHeader from '../PreHeader';
import Header from '../Header';

import {
  activeEntitySelector,
  quickViewDataSelector,
  quickViewSettingsSelector,
} from '../../../selectors';

const FinanceQVContent = ({ onClose }) => {
  const app = useSelector(activeEntitySelector);
  const data = useSelector(quickViewDataSelector);
  const { aqv, aqvDetails } = useSelector(quickViewSettingsSelector);

  const performance = data?.finance_performance || {};
  const widgets = data?.finance_widgets || {};

  const { advanced_metrics_insights } = widgets;
  const isAdvancedDataAbsent =
    isEmpty(advanced_metrics_insights) || advanced_metrics_insights.no_data;

  return (
    <>
      <PreHeader app={app} onClose={onClose} />
      <div className="app-quick-view__scrollable-container">
        <Header app={app} widgets={widgets} settings={aqvDetails} onClose={onClose} />
        <div className="app-quick-view__finance-content-wrapper">
          {!isEmpty(data.forecasts?.forecasts) && (
            <KpiForecastsQV app={app} forecasts={data.forecasts.forecasts} />
          )}
          <FinanceInsightsWidgets
            app={app}
            widgets={widgets}
            isAdvancedDataAbsent={isAdvancedDataAbsent}
            settings={aqv.finance_widgets}
          />
          {!isAdvancedDataAbsent && (
            <AdvancedDataPerformance
              widgets={widgets}
              data={data}
              settings={aqv.advanced_time_series}
            />
          )}
          <FinanceGranularityChartWidgets
            widgets={performance}
            settings={aqv.finance_performance}
          />
        </div>
      </div>
    </>
  );
};

FinanceQVContent.propTypes = {
  onClose: T.func.isRequired,
};

export default FinanceQVContent;
